"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, // https://stackoverflow.com/a/67793914
"default", {
    enumerable: true,
    get: function() {
        return createKonvaPolygon;
    }
});
const _konva = /*#__PURE__*/ _interop_require_default(require("konva"));
const _KonvaTextLabel = /*#__PURE__*/ _interop_require_default(require("./KonvaTextLabel.js"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function createKonvaPolygon(shape = {}, config = {}) {
    const { name = "marker-polygon", rotation, strokeWidth = 2, // strokeEnabled = false,
    isEditable = true, onTextChange = ()=>{} } = config, listeners = _object_without_properties(config, [
        "name",
        "rotation",
        "strokeWidth",
        "isEditable",
        "onTextChange"
    ]);
    const tension = 1;
    const labelOffset = 10;
    const { points = [] } = shape;
    if (points.length < 1) {
        return null;
    }
    const xMin = Math.min(...points.map((point)=>point.x));
    const xMax = Math.max(...points.map((point)=>point.x));
    const yMax = Math.max(...points.map((point)=>point.y));
    const polygonWidth = xMax - xMin;
    const group = new _konva.default.Group();
    const line = new _konva.default.Line(_object_spread({
        id: shape.id,
        name,
        points: points.map((p)=>[
                p.x,
                p.y
            ]).flat(),
        stroke: "white",
        tension
    }, listeners));
    const markerLabel = (0, _KonvaTextLabel.default)(_object_spread_props(_object_spread({}, shape), {
        points: [
            {
                x: xMin + polygonWidth / 2,
                y: yMax + labelOffset
            }
        ]
    }), {
        // config
        rotation,
        strokeWidth,
        isEditable,
        onTextChange
    });
    group.add(line);
    group.add(markerLabel);
    return group;
}
